module.exports = __webpack_public_path__ + "img/rejected.0016ab6c.svg";